import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  public progressBarData = null;
  public windowWidth: number;
  @Input() progressBarInfo = null;
  constructor() { }

  ngOnInit() {
    this.windowWidth = window.innerWidth;
  }

  ngOnChanges() {
    this.progressBarData = Object.assign({}, this.progressBarInfo);
    if (this.progressBarData) {
      this.progressBarData.percentage = this.progressBarData.percentage === undefined ?
                                            this.progressBarData.calculativePercentage : this.progressBarData.percentage;
      this.progressBarData.widthPercentage = this.progressBarData.percentage === undefined ?
                                            `${this.progressBarData.calculativePercentage}%` : `${this.progressBarData.percentage}%`;
    }
  }

}
